/** @format */

import { AfterViewInit, Component, ComponentRef, Input, ViewChild, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';

import { HmfDrawerComponent } from '@dsg-tech/homefield-angular';
import { Store } from '@ngrx/store';

import {
	AppProductReviewState,
	ComponentHandlerService,
	cleanReviewFilters,
	cleanSelectedTag,
	closeProductReviewDrawer,
	ProductReviewDrawerType,
	removeSearchFilter,
	removeSortFilter
} from '@product-reviews/data-access';

@Component({
	selector: 'product-reviews-review-information-drawer',
	templateUrl: './review-information-drawer.component.html',
	styleUrl: './review-information-drawer.component.scss',
	standalone: false
})
export class ReviewInformationDrawerComponent implements AfterViewInit {
	@Input() selfReference: ComponentRef<ReviewInformationDrawerComponent> | null = null;
	@Input() reviewDrawerType: ProductReviewDrawerType = ProductReviewDrawerType.NONE;
	@Input() drawerTitle = '';
	@Input() hasNewReviewsEnhancement = false;
	@Input() isMobileSize = false;
	@Input() isFirstPanelOpen = true;
	drawerTypeOptions = ProductReviewDrawerType;

	@ViewChild(HmfDrawerComponent, { static: true }) drawerComponent: HmfDrawerComponent;

	constructor(
		private store: Store<AppProductReviewState>,
		private componentHandlerService: ComponentHandlerService,
		@Inject(DOCUMENT) private document: Document
	) {}

	ngAfterViewInit(): void {
		setTimeout(() => {
			this.openDrawer();
		}, 0);
	}

	// TODO: Remove this when homefield drawer supports host listeners
	activeKeydownEvent({ key }: KeyboardEvent): void {
		const closeButton = this.document.querySelector(
			'hmf-drawer .reviews-information-modal .hmf-modal-container-close'
		);

		if (key === 'Enter' && closeButton === this.document.activeElement) {
			this.closeDrawer();
		}
	}

	closeDrawer(): void {
		if (this.selfReference) {
			this.clearStore();
			this.deleteComponent();
		}
	}

	private openDrawer(): void {
		this.drawerComponent?.openDrawer();
	}

	private deleteComponent(): void {
		this.componentHandlerService.remove(this.selfReference);
		this.selfReference = null;
	}

	private clearStore(): void {
		this.store.dispatch(closeProductReviewDrawer());
		this.store.dispatch(cleanReviewFilters());
		this.store.dispatch(removeSearchFilter());
		this.store.dispatch(cleanSelectedTag());
		this.store.dispatch(removeSortFilter());
	}
}
